<template>
  <div>
    <div v-if="uploader_profiles_enabled && user.is_admin">
      <f-data-table id="uploader-profiles-table"
                    heading="Uploader Profiles"
                    icon="flaticon2-user-1"
                    :static-params="static_params"
                    :data-uri="data_uri"
                    :columns="columns"
                    :selectable-rows="true"
                    :server-side="true">
        <template #_actions>
          <div class="kt-portlet__head-toolbar">
            <div class="kt-portlet__head-wrapper">
              <!-- wasn't working with data toggle, need to figure out why. @click is quick fix -->
              <button
                class="btn btn-ss-standout btn-icon-sm" @click="showAddProfileModal">
                <i class="flaticon2-plus" />New Profile
              </button>
            </div>
          </div>
        </template>
        <template #created_at="props">
          {{ formatDate(props.row.created_at, `DD/MM/YYYY, hh:mm:ss`) }}
        </template>
        <template #approval_required="props">
          <span v-if="props.row.approval_required === 1" style="color: green; font-weight: bold;">Yes</span>
          <span v-else>No</span>
        </template>
        <template #users="props">
          <span>
            <span v-for="(user, index) in props.row.users" :key="index">
              {{ user.name }}<span v-if="(index+1 < props.row.users.length)">, </span>
            </span>
          </span>
        </template>

        <template #actions="props">
          <button
            type="button" class="btn btn-sm btn-ss"
            title="Edit Uploader Profile"
            @click="showEditProfileModal(props.row)">
            <i class="la la-edit" /> Edit
          </button>
          <button
            type="button" class="btn btn-sm btn-ss-danger"
            title="Delete Uploader Profile"
            @click="deleteUploaderProfile(props.row)">
            <i class="la la-trash" /> Delete
          </button>
        </template>
      </f-data-table>
      <vjs-modal name="add-uploader-profile" v-bind="modal_props">
        <uploader-profile-form modal-name="add-uploader-profile" :uploader-profile="uploader_profile_to_edit" />
      </vjs-modal>
    </div>
    <div v-else-if="!user.is_admin">
      Only users with Admin or Organisation Admin access can manage Uploader Profiles. Please contact your account administrator.
    </div>
  </div>
</template>

<script>
import VjsModal from "VueModals/VjsModal";
import UploaderProfileForm from "VuePartials/App/ThirdPartyUploader/UploaderProfilesForm";
import FDataTable from "VuePartials/App/Storage/FDataTable/FDataTable.vue";

export default {
  components: {
    FDataTable,
    UploaderProfileForm,
    VjsModal,
  },
  data: () => ({
    user: window.user,
    uploader_profiles_enabled: true,
    data_uri: `/api/v1/uploader-profiles`,
    uploader_profile_to_edit: null,
    static_params: [
      {
        field: `with_users`,
        value: true,
      },
    ],
    columns: [
      {
        display: "Name",
        field: "name",
        never_clip: true,
      },
      {
        display: "Requires Approval",
        field: "approval_required",
      },
      {
        display: "Used By",
        field: "users",
      },
      {
        display: "Created At",
        field: 'created_at',
      },
      {
        display: "Actions",
        field: "actions",
        sortable: false,
        clip_resistance: 1,
      },
    ],
  }),
  computed: {
    modal_props() {
      if (!this.nullish(this.uploader_profile_to_edit)) {
        return {
          title: `Edit Uploader Profile`,
          icon: `la la-edit`,
        };
      }
      return {
        title: `Create an Uploader Profile`,
        icon: `la la-plus`,
      };
    },
  },
  beforeMount() {
    this.uploader_profiles_enabled = this.permissionsCanAccessFeature('uploader_profiles');
  },
  methods: {
    deleteUploaderProfile(uploader_profile) {
      axios.delete(`api/v1/uploader-profiles/${uploader_profile.uuid}`).then(() => {
        toastr.success("Uploader Profile Deleted");
        window.EventBus.$emit('uploader-profiles-table-reload');
      }).catch((error) => {
        this.handleAxiosError(error);
      });
    },
    async showEditProfileModal(uploader_profile) {
      this.uploader_profile_to_edit = uploader_profile;
      await this.fireModal(`add-uploader-profile`);
    },
    async showAddProfileModal() {
      this.uploader_profile_to_edit = null;
      await this.fireModal(`add-uploader-profile`);
    },
  },
};
</script>
